import { useCallback } from 'react';

import { useQueryParamValue } from 'src/app/shared/hooks/location';
import { useCurrentUserIdAsync } from 'src/app/shared/hooks/session';
import type { ShareAction, ShareChannel } from 'src/app/shared/hooks/share';
import { useAvailableShareActions } from 'src/app/shared/hooks/share';
import { isLoaded } from 'src/app/shared/utils/async';

import { usePetitionDetails } from '../../../../../hooks/petitionDetails';

export function useQRCodeShare(): ShareAction | null {
	const petitionDetails = usePetitionDetails();
	const sourceLocation = useQueryParamValue('source_location');
	const currentUserState = useCurrentUserIdAsync();
	const currentUserId = isLoaded(currentUserState) ? currentUserState.value : undefined;

	const getTrackingData = useCallback(
		(_channel: ShareChannel) => ({
			location: 'qr_code_download',
			view_context: 'petition_details',
			own_petition: petitionDetails.user.id === currentUserId,
			context: 'petition_details',
			petition_id: `petition_${petitionDetails.id}`,
			source_location: sourceLocation,
		}),
		[currentUserId, petitionDetails.id, petitionDetails.user.id, sourceLocation],
	);

	// We only use the share action helper to handle the share tracking.
	// The short URL is built by the QR generator in GraphQL.
	const channels = ['qrcode'] as const;
	const actionsState = useAvailableShareActions(channels, {
		trackingEventName: 'share_petition',
		getUrl: (_channel: ShareChannel) => '',
		getTrackingData,
		getContent: (_channel: ShareChannel) => '',
		disableShortLinks: true,
	});
	return actionsState[0] ?? null;
}
